import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

import { ERROR_MESSAGES } from "constants/validation"

/**
 * Conversion Schema
 * Represents a successful conversion from an affiliate link
 * Base schema is loose to allow loading legacy data.
 */
export const ConversionSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    conversionId: Yup.number().nullable(),
    utmId: Yup.number().nullable(),
    conversionDatetime: Yup.date().nullable(),
    noConversion: Yup.string().nullable(),
    uniqueConversion: Yup.string().nullable(),
  })

/**
 * Conversion Validation Schema
 * Strict rules applied only during form submission.
 */
export const ConversionValidationSchema = ConversionSchema.clone().shape({
  conversionId: Yup.number().required(ERROR_MESSAGES.REQUIRED),
})
